/*
 * @Author: Teemo Ding
 * @Date: 2021-06-29 16:16:03
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-03-01 15:28:54
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/config.ts
 */

const settings = (salesChannelUuid, isMini, { getI18n }) => [
  ...(isMini
    ? [
        {
          icon: 'iconsettings',
          name: getI18n('salesChannelSettings.config.miniProgramSetting'),
          desc: getI18n('salesChannelSettings.config.miniProgramSettingDesc'),
          linkTo: `/salesChannel/setting/miniProgramSetting/${salesChannelUuid}`,
        },
      ]
    : []),
  {
    icon: 'iconsettings',
    name: getI18n('salesChannelSettings.config.invoice'),
    desc: getI18n('salesChannelSettings.config.invoiceDesc'),
    linkTo: `/salesChannel/setting/invoice/${salesChannelUuid}`,
  },
  {
    icon: 'iconsettings',
    name: getI18n('salesChannelSettings.config.digitalMarketing'),
    desc: getI18n('salesChannelSettings.config.digitalMarketingDesc'),
    linkTo: `/salesChannel/setting/digitalMarketing/${salesChannelUuid}`,
  },
  {
    icon: 'iconsettings',
    name: getI18n('salesChannelSettings.config.currency'),
    desc: getI18n('salesChannelSettings.config.currencyDesc'),
    linkTo: `/salesChannel/setting/currency/${salesChannelUuid}`,
  },
  {
    icon: 'iconsettings',
    name: getI18n('salesChannelSettings.config.logistics'),
    desc: getI18n('salesChannelSettings.config.logisticsDesc'),
    linkTo: `/salesChannel/setting/logistics/${salesChannelUuid}`,
  },
  {
    icon: 'iconsettings',
    name: getI18n('salesChannelSettings.config.localisation'),
    desc: getI18n('salesChannelSettings.config.localisationDesc'),
    linkTo: `/salesChannel/setting/localisation/${salesChannelUuid}`,
  },
  {
    icon: 'iconsettings',
    name: getI18n('salesChannelSettings.config.inventory'),
    desc: getI18n('salesChannelSettings.config.inventoryDesc'),
    linkTo: `/salesChannel/setting/inventory/${salesChannelUuid}`,
  },
  {
    icon: 'iconsettings',
    name: getI18n('salesChannelSettings.config.language'),
    desc: getI18n('salesChannelSettings.config.languageDesc'),
    linkTo: `/salesChannel/setting/language/${salesChannelUuid}`,
  },
  {
    icon: 'iconsettings',
    name: getI18n('salesChannelSettings.config.order'),
    desc: getI18n('salesChannelSettings.config.orderDesc'),
    linkTo: `/salesChannel/setting/order/${salesChannelUuid}`,
  },
  ...(!isMini
    ? [
        {
          icon: 'iconsettings',
          name: getI18n('salesChannelSettings.config.cookies'),
          desc: getI18n('salesChannelSettings.config.cookiesDesc'),
          linkTo: `/salesChannel/setting/cookies/${salesChannelUuid}`,
        },
      ]
    : []),
  {
    icon: 'iconsettings',
    name: getI18n('salesChannelSettings.config.payment'),
    desc: getI18n('salesChannelSettings.config.paymentDesc'),
    linkTo: `/salesChannel/setting/payment/${salesChannelUuid}`,
  },
  {
    icon: 'iconsettings',
    name: getI18n('salesChannelSettings.config.checkout'),
    desc: getI18n('salesChannelSettings.config.checkoutDesc'),
    linkTo: `/salesChannel/setting/checkout/${salesChannelUuid}`,
  },
  {
    icon: 'iconsettings',
    name: getI18n('salesChannelSettings.config.registration'),
    desc: getI18n('salesChannelSettings.config.registrationDesc'),
    linkTo: `/salesChannel/setting/registration/${salesChannelUuid}`,
  },
  {
    icon: 'iconsettings',
    name: getI18n('salesChannelSettings.config.logoManagement'),
    desc: getI18n('salesChannelSettings.config.logoManagementDesc'),
    linkTo: `/salesChannel/setting/logoManagement/${salesChannelUuid}`,
  },
  ...(!isMini
    ? [
        {
          icon: 'iconsettings',
          name: getI18n('salesChannelSettings.config.domainandStatus'),
          desc: getI18n('salesChannelSettings.config.domainandStatusDesc'),
          linkTo: `/salesChannel/setting/domain/${salesChannelUuid}`,
        },
      ]
    : []),
  {
    icon: 'iconsettings',
    name: getI18n('salesChannelSettings.config.tax'),
    desc: getI18n('salesChannelSettings.config.taxDesc'),
    linkTo: `/salesChannel/setting/tax/${salesChannelUuid}`,
  },
  {
    icon: 'iconsettings',
    name: getI18n('salesChannelSettings.config.communication'),
    desc: getI18n('salesChannelSettings.config.communicationDesc'),
    linkTo: `/salesChannel/setting/communication/${salesChannelUuid}`,
  },
];

export { settings };
